<template>
  <div
    class="pics-box"
    @click="selectImage"
  >
    <div
      v-if="imageUrl"
      class="select-pic"
    >
      <img :src="imageUrl">
      <div
        class="delete"
        @click.stop="deleteImage"
      >
        <i class="el-icon-close" />
      </div>
    </div>
    <div
      v-else
      class="upload-box upload-icon"
    >
      <i class="el-icon-camera upload-icon" />
      <span class="tips">选择图片</span>
    </div>

    <!-- 选择图片 -->
    <SpImageSelect
      :image-visible="imageVisible"
      :choose-one="true"
      @closeImageDialog="closeImageDialog"
      @chooseImage="chooseImage"
    />
  </div>
</template>

<script>
export default {
  name: 'SpOnlyPicSelect',
  props: {
    imageUrl: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imageVisible: false
    }
  },
  methods: {
    // 打开选择图片对话框
    selectImage () {
      this.imageVisible = true
    },
    // 关闭商品对话框
    closeImageDialog () {
      this.imageVisible = false
    },
    // 选择图片
    chooseImage (selectdata) {
      if (selectdata.length > 0) {
        this.imageVisible = false
        this.$emit('selectImage', selectdata[0].image_url)
      }
    },
    // 删除图片
    deleteImage () {
      this.$emit('selectImage', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.pics-box {
  width: 90px;
  height: 90px;
  border-radius: 2px;
  .select-pic {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
    .delete {
      display: none;
      width: 16px;
      height: 16px;
      position: absolute;
      right: 0;
      top: 0;
      background: rgba(0, 0, 0, 0.25);
      border-radius: 0px 2px 0px 0px;
      line-height: 16px;
      text-align: center;
      cursor: pointer;
      i {
        color: #fff;
      }
    }
    &:hover {
      .delete {
        display: block;
      }
    }
  }
}
.upload-box {
  // border: 1px dashed #c0ccda;
  border-radius: 2px;
  cursor: pointer;
  overflow: hidden;
  width: 90px;
  height: 90px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #fafafa;

  .upload-icon {
    font-size: 28px;
    color: #949494;
  }

  .tips {
    font-size: 12px;
    color: #949494;
    line-height: 18px;
    margin-top: 8px;
  }

  &:hover {
    border-color: #409eff;
  }
}
</style>
